import { IconButton, IconButtonProps } from '@mui/material'
// import { MatButton } from 'components/buttons'
import { Icon, IconNames } from 'hello-design-system'
import { InkEraserActiveIcon, InkEraserIcon } from 'icons'
// import { LineChevronRight, ClearAllIcon, EraserIcon, TextBoxIcon, PenIcon } from 'icons'

interface NavigationButtonProps {
    id: string
    onClick: IconButtonProps['onClick']
}
type PresentationButtonProps = {
    id?: string
    icon?: IconNames
    onClick?: IconButtonProps['onClick']
    active?: boolean
}

const PresentationButton: React.FC<PresentationButtonProps> = ({ id, icon, onClick, active }) => (
    <IconButton
        id={id}
        onClick={onClick}
        sx={theme => ({
            backgroundColor: active ? theme.palette.action?.hover : theme.palette.grey?.[400],
            color: active ? theme.palette.text?.primary : theme.palette.text?.secondary,
            height: theme.spacing(4),
            width: theme.spacing(4),
            willChange: 'background-color',
            transition: 'background-color 0.2s ease-out'
        })}
    >
        {icon === undefined
            ? <img style={{ width: '16px', height: '16px' }} alt='erase' src={active ? InkEraserActiveIcon : InkEraserIcon} />
            : <Icon sx={{ width: '16px' }} iconName={icon} />
        }
        {/* <img src={icon} /> */}
    </IconButton>
)

const PreviousStepButton: React.FC<NavigationButtonProps> = ({ id, onClick }) => (
    <PresentationButton id={id} icon={'ChevronLeftRounded'} onClick={onClick} />
)
const NextStepButton: React.FC<NavigationButtonProps> = ({ id, onClick }) => (
    <PresentationButton id={id} icon={'ChevronRightRounded'} onClick={onClick} />
)
const TextButton: React.FC<PresentationButtonProps> = ({ id, onClick, active }) => (
    <PresentationButton id={id} icon={'TextFieldsRounded'} onClick={onClick} active={active} />
)
const PenButton: React.FC<PresentationButtonProps> = ({ id, onClick, active }) => (
    <PresentationButton id={id} icon={'EditRounded'} onClick={onClick} active={active} />
)
const EraserButton: React.FC<PresentationButtonProps> = ({ id, onClick, active }) => (
    <PresentationButton id={id} icon={undefined} onClick={onClick} active={active} />
)
const ClearAllButton: React.FC<PresentationButtonProps> = ({ id, onClick, active }) => (
    <PresentationButton id={id} icon={'DeleteRounded'} onClick={onClick} active={active} />
)

export { PreviousStepButton, NextStepButton, TextButton, PenButton, EraserButton, ClearAllButton }
